/* Saíra: menu, busca com sugestões, ampliação de capas e sinopse centralizada */
(function(){

/* ---------- menu mobile ---------- */
var b=document.querySelector('.burger'), nav=document.getElementById('mainnav');
if(b&&nav){
  b.addEventListener('click',function(){
    var open=nav.classList.toggle('open');
    b.setAttribute('aria-expanded',open?'true':'false');
    b.setAttribute('aria-label',open?'Fechar menu':'Abrir menu');
  });
  nav.addEventListener('click',function(e){
    if(e.target.tagName==='A'&&window.innerWidth<=760){
      nav.classList.remove('open'); b.setAttribute('aria-expanded','false'); b.setAttribute('aria-label','Abrir menu');
    }
  });
}
document.querySelectorAll('nav.main .catgat').forEach(function(g){
  function alterna(){ g.setAttribute('aria-expanded', g.getAttribute('aria-expanded')==='true'?'false':'true'); }
  g.addEventListener('click',alterna);
  g.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); alterna(); } });
});

function nrm(s){return (s||'').normalize('NFKD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();}
function esc(s){return String(s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

/* ---------- busca ---------- */
var form=document.querySelector('form.search'), inp=form&&form.querySelector('input');
if(form&&inp){
  form.style.position='relative';
  var box=document.createElement('div');box.className='sbx';box.hidden=true;form.appendChild(box);
  var IDX=null, carregando=null, achados=[], sel=-1;
  var CHAVE='saira-indice-v1';
  function carrega(){
    if(IDX) return Promise.resolve(IDX);
    if(carregando) return carregando;
    try{ var c=sessionStorage.getItem(CHAVE); if(c){ IDX=JSON.parse(c); return Promise.resolve(IDX); } }catch(e){}
    function pega(u){ return fetch(u,{credentials:'same-origin'}).then(function(r){return r.ok?r.text():'[]';}).then(function(t){ try{return JSON.parse(t);}catch(e){return [];} }).catch(function(){return [];}); }
    carregando=Promise.all([pega('/collections/all?view=indice'),pega('/pages/autores?view=indice')]).then(function(rs){
      IDX=rs[0].concat(rs[1]).filter(Boolean).map(function(d){ d.q=nrm(d.t+' '+(d.s||'')+' '+(d.q||'')); return d; });
      try{ sessionStorage.setItem(CHAVE,JSON.stringify(IDX)); }catch(e){}
      return IDX;
    });
    return carregando;
  }
  function busca(q){
    var ts=nrm(q).split(' ').filter(Boolean);
    if(!ts.length||!IDX) return [];
    return IDX.map(function(d){
      var p=0;
      for(var i=0;i<ts.length;i++){ var k=d.q.indexOf(ts[i]); if(k<0) return null; p+=(k===0?3:1); }
      if(nrm(d.t).indexOf(ts[0])===0) p+=4;
      if(d.k==='livro') p+=1;
      return {d:d,p:p};
    }).filter(Boolean).sort(function(a,b){return b.p-a.p}).slice(0,8).map(function(x){return x.d});
  }
  function pinta(){
    if(!achados.length){ box.innerHTML='<p class="vazio">Nada encontrado. Tente outro título, autor ou tema.</p>'; box.hidden=false; return; }
    box.innerHTML=achados.map(function(d,i){
      var im=d.i?'<img src="'+esc(d.i)+'" alt="">':'<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="">';
      return '<a href="'+esc(d.u)+'" class="'+(i===sel?'on':'')+'">'+im+'<span><span class="tt">'+esc(d.t)+'</span><span class="ss" style="display:block">'+esc(d.s)+'</span></span></a>';
    }).join('');
    box.hidden=false;
  }
  function atualiza(){
    sel=-1;
    if(inp.value.trim().length<2){ box.hidden=true; return; }
    carrega().then(function(){ achados=busca(inp.value); pinta(); });
  }
  inp.addEventListener('focus',function(){ carrega(); });
  inp.addEventListener('input',atualiza);
  inp.addEventListener('keydown',function(e){
    if(box.hidden) return;
    if(e.key==='ArrowDown'){sel=Math.min(sel+1,achados.length-1);pinta();e.preventDefault();}
    else if(e.key==='ArrowUp'){sel=Math.max(sel-1,0);pinta();e.preventDefault();}
    else if(e.key==='Escape'){box.hidden=true;}
  });
  form.addEventListener('submit',function(e){
    if(!inp.value.trim()){ e.preventDefault(); return; }
    if(sel>=0&&achados[sel]){ e.preventDefault(); location.href=achados[sel].u; }
  });
  document.addEventListener('click',function(e){ if(!form.contains(e.target)) box.hidden=true; });
}

/* ---------- ampliar capas ---------- */
var zs=document.querySelectorAll('img.zoom');
if(zs.length){
  var lb=document.createElement('div');lb.className='lbx';
  lb.innerHTML='<button class="x" type="button" aria-label="Fechar">&times;</button><img alt="">';
  document.body.appendChild(lb);
  var lbi=lb.querySelector('img');
  lb.addEventListener('click',function(e){ if(e.target!==lbi) lb.classList.remove('on'); });
  Array.prototype.forEach.call(zs,function(im){
    im.addEventListener('click',function(){
      lbi.src=im.getAttribute('data-zoom')||im.currentSrc||im.getAttribute('src');
      lbi.alt=im.getAttribute('alt')||''; lb.classList.add('on');
    });
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') lb.classList.remove('on'); });
}
})();

/* Páginas de livro: o bloco "A história" fica centralizado no espaço azul
   entre a borda esquerda da tela e o começo da ilustração (mesmo respiro dos dois lados). */
(function(){
  function centraSinopse(){
    document.querySelectorAll('.sin .singrid').forEach(function(g){
      var txt=g.firstElementChild, img=g.querySelector('.ph img');
      if(!txt||!img) return;
      txt.style.transform='';
      if(window.innerWidth<=880||!img.complete||!img.naturalWidth) return;
      var L=Infinity,R=-Infinity;
      txt.querySelectorAll('p').forEach(function(p){
        var r=document.createRange(); r.selectNodeContents(p);
        Array.prototype.forEach.call(r.getClientRects(),function(c){ if(c.width){L=Math.min(L,c.left);R=Math.max(R,c.right);} });
      });
      if(!isFinite(L)) return;
      var inicioIlustracao=img.getBoundingClientRect().left;
      var esquerdaIdeal=(inicioIlustracao-(R-L))/2;
      txt.style.transform='translateX('+Math.round(esquerdaIdeal-L)+'px)';
    });
  }
  function agenda(){ window.requestAnimationFrame(centraSinopse); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',agenda); else agenda();
  window.addEventListener('load',agenda);
  window.addEventListener('resize',agenda);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(agenda);
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('.sin .ph img').forEach(function(i){ i.addEventListener('load',agenda); });
  });
})();
